import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api/v1';

const mechanicApi = axios.create({ baseURL: BASE_URL });

mechanicApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('mechanicToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auto-logout on expired/invalid mechanic session (mirrors the user axios).
mechanicApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('mechanicToken');
      if (!window.location.pathname.startsWith('/mechanic/login')) {
        window.location.href = '/mechanic/login';
      }
    }
    return Promise.reject(err);
  }
);

export const mechanicLogin = (data) =>
  mechanicApi.post('/mechanic/login', data).then((r) => r.data.data);

export const forgotMechanicPassword = (email) =>
  mechanicApi.post('/mechanic/forgot-password', { email }).then((r) => r.data);

export const resetMechanicPassword = (data) =>
  mechanicApi.post('/mechanic/reset-password', data).then((r) => r.data);

export const getMechanicMe = () =>
  mechanicApi.get('/mechanic/me').then((r) => r.data.data.mechanic);

export const getMechanicJobs = (params) =>
  mechanicApi.get('/mechanic/jobs', { params }).then((r) => r.data.data);

export const updateMechanicJobStatus = (id, data) =>
  mechanicApi.put(`/mechanic/jobs/${id}/status`, data).then((r) => r.data);

export const updateMechanicProfile = (data) =>
  mechanicApi.put('/mechanic/profile', data).then((r) => r.data.data.mechanic);

export const changeMechanicPassword = (data) =>
  mechanicApi.put('/mechanic/change-password', data).then((r) => r.data);

export const getMechanicNotifications = (params) =>
  mechanicApi.get('/mechanic/notifications', { params }).then((r) => r.data.data);

export const markNotificationRead = (id) =>
  mechanicApi.patch(`/mechanic/notifications/${id}/read`).then((r) => r.data);

export const markAllNotificationsRead = () =>
  mechanicApi.patch('/mechanic/notifications/read-all').then((r) => r.data);
